module.exports = __webpack_public_path__ + "img/Twitter.3660e25b.svg";